import EntryHeader from './EntryHeader'

export default EntryHeader
